import { useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DefaultError } from './DefaultError';

export const NotFoundError = () => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <DefaultError
      title={t('common.errors.notFound.title')}
      description={t('common.errors.notFound.description')}
      actions={[
        {
          label: t('common.goBack'),
          action: () => {
            if (router.history.canGoBack()) {
              router.history.back();
            } else {
              router.navigate({ to: '/' });
            }
          },
        },
      ]}
    />
  );
};
